import { useField } from 'formik'
import SelectInput, { SelectOption } from '../SelectInput'
import { withHistoricalOption } from './selectHistoricalOption'

// Listas restritas às opções que o Rodopar aceita para o lote — não usar em outros
// módulos (contratos, cotações, programações continuam usando a lista completa em
// TipoNegociacaoEmpresaSelectInput).
export type TipoNegociacaoEmpresaLote =
  | 'TONELADA'
  | 'RS_POR_VIAGEM'
  | 'QUILOMETRO_RODADO'

export const tiposNegociacaoEmpresaLote: SelectOption<TipoNegociacaoEmpresaLote>[] =
  [
    { value: 'TONELADA', label: 'R$ por tonelada' },
    { value: 'RS_POR_VIAGEM', label: 'R$ por Viagem' },
    { value: 'QUILOMETRO_RODADO', label: 'R$ por quilômetro rodado' }
  ]

export type TipoNegociacaoSubcontratadoLote =
  | 'TONELADA'
  | 'RS_POR_VIAGEM'
  | 'MARGEM'

export const tiposNegociacaoSubcontratadoLote: SelectOption<TipoNegociacaoSubcontratadoLote>[] =
  [
    { value: 'TONELADA', label: 'R$ por tonelada' },
    { value: 'RS_POR_VIAGEM', label: 'R$ por Viagem' },
    { value: 'MARGEM', label: 'Por Margem' }
  ]

const LABELS_HISTORICOS: Record<string, string> = {
  QUILOMETRO_RODADO: 'R$ por quilômetro rodado',
  METRO_CUBICO: 'R$ por Metro Cúbico',
  RS_POR_QTDADE_VOLUMES: 'R$ por Quantidade de Volumes',
  COTACAO_LIVRE: 'Cotação Livre',
  COTACAO_DINAMICA: 'Cotação Dinâmica'
}

interface Props {
  name: string
  label?: string
  isRestrictedEdit?: boolean
  tipo?: 'empresa' | 'subcontratado'
}

const TipoNegociacaoLoteSelectInput = ({
  name,
  label,
  isRestrictedEdit,
  tipo = 'empresa'
}: Props) => {
  const [field] = useField(name)
  const baseOptions =
    tipo === 'subcontratado'
      ? tiposNegociacaoSubcontratadoLote
      : tiposNegociacaoEmpresaLote
  const options = withHistoricalOption(
    baseOptions,
    field.value,
    LABELS_HISTORICOS
  )

  return (
    <SelectInput
      name={name}
      label={
        label ||
        (tipo === 'subcontratado'
          ? 'Tipo Negociação Subcontratado'
          : 'Tipo Negociação Empresa')
      }
      options={options}
      disabled={isRestrictedEdit}
    />
  )
}

export default TipoNegociacaoLoteSelectInput
